import {AnyAction} from 'redux';
import {FrameActions} from '@mc/react-frame';
import {Coordinate, ZoomOptions} from '../types';
import {FeatureIdType} from '../enums';

/**
 * Akce mapy.
 */
const MapActions = {
    /**
     * Přenačte vrstvu.
     *
     * @param area - Oblast store.
     * @param layerId - ID vrstvy. Může obsahovat wildcard znak `*` pro specifikování masky vrstev.
     *                  Například `app:layer:*` přenačtě vrstvy `app:layer:1`, `app:layer:2` atd.
     * @param featureIds - ID features pro přenačtení ve vrstvách. Při neuvedení jsou přenačteny celé vrstvy.
     * @param featureIdType - Typ ID features.
     * @returns Akce.
     */
    reloadLayer(
        area: string,
        layerId: string,
        featureIds?: Array<string | number>,
        featureIdType?: FeatureIdType,
    ): AnyAction {
        return FrameActions.postMessage(area, {
            type: 'RELOAD_LAYER',
            id: layerId,
            featureIds,
            featureIdType,
        });
    },

    /**
     * Přenačte detail feature.
     *
     * @param area - Oblast store.
     * @param featureId - ID feature.
     * @param layerId - ID vrstvy.
     * @returns Akce.
     */
    reloadDetail(area: string, featureId: string | number, layerId: string): AnyAction {
        return FrameActions.postMessage(area, {
            type: 'RELOAD_DETAIL',
            id: featureId,
            layerId,
        });
    },

    /**
     * Zavře aktivní detail feature.
     *
     * @param area - Oblast store.
     * @param collapse - Zda zároveň skrýt i panel ve kterém je detail zobrazen.
     * @returns Akce.
     */
    closeDetail(area: string, collapse: boolean): AnyAction {
        return FrameActions.postMessage(area, {
            type: 'CLOSE_DETAIL',
            collapse,
        });
    },

    /**
     * Provede zoom na vrstvu.
     * Vrstva je v případě nutnosti donačtena a zobrazena.
     *
     * @param area - Oblast store.
     * @param layerId - ID vrstvy.
     * @param options - Volitelné parametry.
     * @returns Akce.
     */
    zoomOnLayer(area: string, layerId: string, options: ZoomOptions = {}): AnyAction {
        const {zoomPadding, zoomRatio, zoomMinScale, padding} = options;

        return FrameActions.postMessage(area, {
            type: 'LAYER_ZOOM',
            id: layerId,
            zoomPadding: padding || zoomPadding, // zoomPadding je původní jméno, zachováno pro zpětnou kompatibilitu
            zoomRatio,
            zoomMinScale,
        });
    },

    showPnuPath(area: string, features: Array<Coordinate>, merge: boolean): AnyAction {
        return FrameActions.postMessage(area, {
            type: 'SHOW_PNU_PATH',
            features,
            merge,
        });
    },

    hidePnuPath(area: string): AnyAction {
        return FrameActions.postMessage(area, {
            type: 'HIDE_PNU_PATH',
        });
    },
};

export default MapActions as Readonly<typeof MapActions>;
